import { Reveal } from "@/components/site/Reveal";
import { caseStudy } from "@/data/content";

export const CaseStudy = () => (
  <section className="bg-background" data-testid="case-study-section">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-28">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
          {caseStudy.eyebrow}
        </p>
        <h2 className="mt-3 max-w-xl font-serif-accent text-3xl font-medium tracking-tight text-foreground sm:text-4xl">
          {caseStudy.title}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">Lokalita · {caseStudy.location}</p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <figure>
            <img
              src={caseStudy.mainImage}
              alt={caseStudy.mainImageAlt}
              className="aspect-[3/4] w-full rounded-md object-cover"
              loading="lazy"
            />
            <figcaption className="mt-2 text-xs text-muted-foreground">Dokončený výsledek</figcaption>
          </figure>
        </Reveal>
        <div className="flex flex-col justify-between gap-10 lg:col-span-7">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            {caseStudy.sections.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.1}>
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">
                  {s.label}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-foreground">{s.text}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="grid grid-cols-2 gap-4">
              <figure>
                <img
                  src={caseStudy.progressImage}
                  alt={caseStudy.progressImageAlt}
                  className="h-56 w-full rounded-md object-cover sm:h-72"
                  loading="lazy"
                />
                <figcaption className="mt-2 text-xs text-muted-foreground">Původní stav</figcaption>
              </figure>
              <figure>
                <img
                  src={caseStudy.detailImage}
                  alt={caseStudy.detailImageAlt}
                  className="h-56 w-full rounded-md object-cover sm:h-72"
                  loading="lazy"
                />
                <figcaption className="mt-2 text-xs text-muted-foreground">Dokončený stav</figcaption>
              </figure>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
